import React from 'react';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Skeleton from 'react-loading-skeleton';
import Grid from '@material-ui/core/Grid';
import {
  Card, CardContent, Divider, Hidden,
} from '@material-ui/core/';

const role = {
  politician: 'Politiker',
  admin: 'Administrator',
  superadmin: 'Superadministrator',
  secretary: 'Sekretær',
  observer: 'Observatør',
  other: 'Andre',
};

const ListValues = ({ values, isLoading }) => (
  Array.isArray(values)
    ? values.map((item, index) => [
      index !== 0 && (
        <Grid item xs={12} key={`${item}-divider`}>
          <Divider />
        </Grid>
      ),
      <Grid item xs={6} sm={3} key={`${item}-from`}>
        <Typography variant="body1" color="primary">{isLoading ? '' : 'Fra'}</Typography>
        {isLoading ? <Skeleton height="1rem" /> : <Typography variant="body1">{`${item.Fra}`}</Typography>}
      </Grid>,
      item.Til && (
        <Grid item xs={6} sm={3} key={`${item}-to`}>
          <Typography variant="body1" color="primary">{isLoading ? '' : 'Til'}</Typography>
          {isLoading ? <Skeleton height="1rem" /> : <Typography variant="body1">{`${item.Til}`}</Typography>}
        </Grid>
      ),
      item.Parti && (
        <Grid item xs={12} sm={6} key={`${item}-party`}>
          <Typography variant="body1" color="primary">{isLoading ? '' : 'Parti'}</Typography>
          {isLoading ? <Skeleton height="1rem" /> : <Typography variant="body1">{`${item.Parti}`}</Typography>}
        </Grid>
      ),
      item.Utvalg && [
        <Hidden xsDown key={`${item}-hidden`}><Grid item sm={6} /></Hidden>,
        <Grid item xs={12} sm={6} key={`${item}-committee`}>
          <Typography variant="body1" color="primary">{isLoading ? '' : 'Utvalg'}</Typography>
          {isLoading ? <Skeleton height="1rem" /> : <Typography variant="body1">{`${item.Utvalg}`}</Typography>}
        </Grid>,
        <Grid item xs={12} sm={6} key={`${item}-committee-role`}>
          <Typography variant="body1" color="primary">{isLoading ? '' : 'Rolle'}</Typography>
          {isLoading ? <Skeleton height="1rem" /> : <Typography variant="body1">{`${item.role}`}</Typography>}
        </Grid>,
      ],
    ]) : Object.keys(values).filter(key => values[key]).map(key => (
      key !== 'Relevant informasjon' ? (
        <Grid item xs={12} sm={6} key={key}>
          <Typography variant="body1" color="primary">{key}</Typography>
          {isLoading ? <Skeleton height="1rem" /> : <Typography variant="body1">{`${values[key]}`}</Typography>}
        </Grid>
      ) : (
        <Grid item xs={12} key={key}>
          <Typography variant="body1" color="primary">{key}</Typography>
          {isLoading ? <Skeleton height="1rem" /> : <Typography variant="body1">{`${values[key]}`}</Typography>}
        </Grid>
      )
    ))
);

const InfoCard = ({
  classes, title, value, isLoading, roles,
}) => (
  <Card elevation={0} raised title={title} className={classes.card}>
    <CardContent>
      <Grid container spacing={2}>
        <Grid item xs={12} key={`title--${title}`}>
          <Typography variant="h6" color="primary">
            { title }
          </Typography>
        </Grid>
        {!roles ? <ListValues values={value} isLoading={isLoading} />
          : (value.map(item => (
            <Grid item xs={12} key={`roles--${item}`}>
              <Typography variant="body1">{role[item]}</Typography>
            </Grid>
          )))}
      </Grid>
    </CardContent>
  </Card>
);

InfoCard.propTypes = {
  classes: PropTypes.object.isRequired,
  value: PropTypes.any.isRequired,
  isLoading: PropTypes.bool,
  title: PropTypes.any,
  roles: PropTypes.bool,
};

InfoCard.defaultProps = {
  isLoading: false,
  title: undefined,
  roles: false,
};


const styles = theme => ({
  bold: {
    fontWeight: 'bold',
  },
  card: {
    border: '1px solid',
    borderColor: theme.palette.primary.main,
  },
});

export default withStyles(styles)(InfoCard);
